module.exports = __webpack_public_path__ + "img/eye-gray.942d8ea.png";